export default __webpack_public_path__ + "static/media/answers-mobile.fe9eb89a.PNG";